import type { SupSingleVaultV3 } from "@/types";
import React, { useCallback, useMemo } from "react";

import { useStoredData, useStoredDataDispatch } from "@/store";
import GridBarFiltersAtomHeader from "@/components/Grid/Bar/Filters/Atom/Header";
import GridBarFiltersAtomList from "@/components/Grid/Bar/Filters/Atom/List";

interface GridBarFiltersYieldTypeProps {
  vaults?: SupSingleVaultV3[];
}

export default function GridBarFiltersYieldType({ vaults }: GridBarFiltersYieldTypeProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const values = useMemo(() => {
    return vaults?.reduce((acc, vault) => (acc.includes(vault.yield_type ?? "") || !vault.yield_type ? acc : [...acc, vault.yield_type]), [] as string[]) ?? ([] as string[]);
  }, [vaults]);

  const selectedValues = useMemo(() => (storedData.filters.find(storedFilter => storedFilter.name === "yield_type")?.values ?? []) as string[], [storedData.filters]);

  const handleFilterChange = useCallback(
    (value: string) => {
      const updatedYieldTypes = selectedValues.includes(value) ? [...selectedValues.filter(singleValue => singleValue !== value)] : [...selectedValues, value];
      storedDispatch(
        updatedYieldTypes.length > 0 ? { type: "setFilter", filter: { name: "yield_type", values: updatedYieldTypes } } : { type: "clearFilter", filterName: "yield_type" }
      );
    },
    [selectedValues, storedDispatch]
  );

  return (
    <GridBarFiltersAtomHeader name="yield_type" title="Yield Type">
      <GridBarFiltersAtomList selectedValues={selectedValues} values={values} onChange={handleFilterChange} />
    </GridBarFiltersAtomHeader>
  );
}
